import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

type BulletProps = PropsWithChildren;

const Bullet: FC<BulletProps> = ({ children }) => (
  <li className={`text-d-h4 xl:text-d-lg`}>
    <div className="flex">
      <img
        className="h-[32px] md:h-[40px] w-auto mr-4"
        src="https://images.ctfassets.net/0sea1vycfyqy/17FfSAhtv9Xc9gtKtF14dy/8a58ff35d037f0c6e4fc89c43000273e/Green_CheckMark_Brushstroke_Active.png"
        alt="check"
      />
      <div>{children}</div>
    </div>
  </li>
);

export default Bullet;
